import React from "react";
import { Container, Box } from "@material-ui/core";
import Header from "./Header";
import Footer from "./Footer";
import TopHeader from "./TopHeader";
import { MuiThemeProvider } from "@material-ui/core/styles";
import ILALandingPage, { ILALanddingCss } from "../../styles/theme/NewlanddingPageTheme";

const LandingLayout: React.FC<{ children?: React.ReactNode }> = (props) => {
    return (
            <MuiThemeProvider theme={ILALandingPage}>
                <ILALanddingCss />
                <Box
                        display="flex"
                        flexDirection="column"
                        minHeight="100vh"
                >
                    <TopHeader />
                    <Header />

                    {/* Main content */}
                    <Box component="main" flex="1">
                            {props.children}
                    </Box>

                    {/* Sticky footer */}
                    <Footer />
                </Box>
            </MuiThemeProvider>
    );
};

export default LandingLayout;
